export default __webpack_public_path__ + "static/media/Hand.8dbe963b.png";